// extracted by mini-css-extract-plugin
export default {"files":"UploadComponent_files__KtxDP","link":"UploadComponent_link__zj-ra"};